
<div class="parent-div" *ngIf="theme==='v1'">
  <div class="outer-card">
    <button class="close-btn close-thank-you" mat-icon-button>
      <mat-icon (click)="goToFundraiser()">close</mat-icon>
    </button>
    <h3>Congratulations!</h3>
    <h4>Your Fundraiser is live
      <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="4.5" r="4.5" fill="#25D366"/>
      </svg>
    </h4>
    <div class="img-wrapper">
      <img loading="lazy" [attr.data-src]="'/assets/images/thankyou-img.png'" alt="Thank you image" />
      <div class="do-you-know">
        <h4>Did you know?</h4>
          Fundraisers that receive a contribution within the first 24 hours are <b>10x</b> more likely to reach their goals.
      </div>
    </div>
    <p>You can always improve your fundraiser later.<span>
        For now, share it with 3-4 people closest to you and</span>
      <span><b>Get your first contribution today!</b></span>
    </p>
    <div>
      <app-whatsapp-share
        label="Share on Whatsapp"
        class="whatsapp-button"
        [fundraiser]="fundraiser"
        [basicInfo]="basicInfo"
        [isFundraiserEnded]="false"
        messageType="sac_share"
        position="17">
      </app-whatsapp-share>
    </div>
    <div class="skip">We’ve even created a ready-to-send message for you 😎</div>
  </div>
</div>



<app-premium-service-pitch-page [list]="premiumPlanList" [campaignId]="campaignId" type="med" *ngIf="theme === 'v2'" [fundraiser]="fundraiser"></app-premium-service-pitch-page>